/* eslint-disable @typescript-eslint/no-explicit-any */
import { AddToCartType, ProductCardType } from '@/constants'
import { labelPositionProductCard } from '@/constants/positions'
import { useCart, useNotification } from '@/containers'
import type { Product, ProductCompare } from '@/types'
import { getTranslate } from '@/utils/api-interceptors'
import dayjs from 'dayjs'
import isNil from 'lodash/isNil'
import Link from 'next/link'
import { useRouter } from 'next/router'
import StarRatings from 'react-star-ratings'
import ImageOptimize from '../ImageOptimize'
import Price from '../Price'
import ProgressBar from '../ProgressBar'
import Countdown from './Countdown'
import { assetUrl } from '@/utils/asset-url'

// import PolicyCard from './PolicyCard'
export interface ProductProps {
  product: Product
  type?: string
  layout?: number
  className?: string
  showCompare?: boolean
  showDeal?: boolean
  showRate?: boolean
  showCountDown?: boolean
  handleAddToCompare?: (product: Product, isCompare: boolean) => void
  productCompares?: ProductCompare[]
}

const ProductCard = ({
  className,
  product,
  type,
  layout,
  showCompare,
  handleAddToCompare,
  productCompares,
  showDeal,
  showRate = true,
  showCountDown = true,
}: ProductProps) => {
  const { systemConfig } = useNotification()
  // const { token } = useAuth()
  /*const voucherDisplay = product?.coupons?.sort(
    (a: any, b: any) => b?.updatedAt - a?.updatedAt
  )[0]
  const finalPriceWithPercent = (
    product?.finalPrice -
    (product?.finalPrice * voucherDisplay?.percentValue) / 100
  )
    .toLocaleString(Languages.VN, {
      style: 'currency',
      currency: 'VND',
    })
    .replace(/\s₫/g, 'đ')
  const finalPriceWithFixed = (
    product?.finalPrice - voucherDisplay?.fixedValue
  ).toLocaleString(Languages.VN, {
    style: 'currency',
    currency: 'VND',
  })*/

  const isCompare = () => {
    return productCompares
      ? !isNil(productCompares.find(e => e._id === product?._id))
      : false
  }

  const { addToCart, cartLoading } = useCart()
  const router = useRouter()

  return (
    <div
      className={`productCard relative ${
        type !== ProductCardType.FLASH_SALE ? '' : ''
      } ${className ? className : ''} ${type ? type : ''} ${
        layout ? 'l' + layout : ''
      } ${type == ProductCardType.TRENDING ? 'rounded-sm' : ''}`}
    >
      <div
        className={`itemProducts h-full items-center overflow-hidden rounded relative ${
          layout ? 'l' + layout : ''
        } ${type == ProductCardType.TRENDING ? 'rounded-sm' : ''}`}
      >
        <div
          className={`${
            type == ProductCardType.RELATED ? 'rounded' : 'p-2'
          } image-thumb relative flex items-start justify-center w-full`}
        >
          {product?.labels &&
            product?.labels
              ?.filter(e => e?._id)
              ?.map((item, index) => {
                return (
                  <span
                    className={`${labelPositionProductCard.get(
                      item?.position
                    )} label absolute flex gap-x-2 flex-nowrap overflow-x-auto overflow-y-hidden hiddenScrollBar w-full h-auto`}
                    key={index}
                    style={{ zIndex: 50 + index }}
                  >
                    <ImageOptimize
                      src={item?.image}
                      alt={getTranslate(item?.name)}
                      width={200}
                      height={48}
                      loading='lazy'
                      className={`w-full h-auto`}
                    />
                  </span>
                )
              })}
          {product?.upcomingFsStartTime && (
            <div
              className={`startTimeFS absolute bottom-0 left-2 z-[49] flex h-[21px]
                items-center justify-start gap-[3px] px-2 pl-[20px] text-[12px] font-bold text-white`}
            >
              <span>
                Mở bán lúc {dayjs(product?.upcomingFsStartTime).format('HH:mm')}
              </span>{' '}
            </div>
          )}
          <Link
            href={
              '/' +
              getTranslate(product?.slugs?.value) +
              product?.slugs?.postfix
            }
            className='relative flex w-[80%] max-h-[80%] overflow-hidden pt-[80%] focus:border-0 focus:outline-0'
          >
            <ImageOptimize
              className='productImage absolute left-0 top-0 aspect-square h-full w-full object-cover'
              src={
                product?.thumbnail
                  ? product?.thumbnail
                  : systemConfig?.imagePlaceholder ||
                    process.env.NEXT_PUBLIC_IMAGE_PLACEHOLDER ||
                    ''
              }
              alt={getTranslate(product?.name)}
              width={160}
              height={160}
              loading='lazy'
              thumbnail
            />
          </Link>
          {type == ProductCardType.FLASH_SALE &&
            product?.flashSale &&
            product?.flashSale?.soldQuantity >=
              product?.flashSale?.quantity && (
              <ImageOptimize
                className='productImage absolute left-0 top-0  aspect-square h-full w-full object-cover z-20'
                src='/assets/images/sold-out.png'
                alt={getTranslate(product?.name)}
                width={160}
                height={160}
                loading='lazy'
                thumbnail
              />
            )}
          {product?.flashSale && showCountDown && (
            <Countdown
              productId={product?._id}
              endTime={product?.flashSale?.endTime}
              type={ProductCardType.PRODUCT_CARD}
              className={
                type == ProductCardType.RELATED ? 'justify-center bottom-2' : ''
              }
            />
          )}
        </div>
        <div className={`w-full pt-2 px-2 text-left`}>
          <Link
            href={
              '/' +
              getTranslate(product?.slugs?.value) +
              product?.slugs?.postfix
            }
            className={`${
              type == ProductCardType.RELATED ? '' : ''
            } mb-2 line-clamp-2 block h-[35px] overflow-hidden text-ellipsis text-titleProduct text-[#000000] focus:border-0 focus:outline-none`}
          >
            {getTranslate(product?.name)}
          </Link>
          <Price
            type={type}
            classes=''
            link={
              '/' +
              getTranslate(product?.slugs?.value) +
              product?.slugs?.postfix
            }
            originPrice={product?.price}
            finalPriceText={product?.finalPriceText}
            finalPrice={
              product?.upcomingFsStartTime
                ? (product?.finalPriceText as unknown as number)
                : type == ProductCardType.FLASH_SALE &&
                  product?.flashSale &&
                  product?.flashSale?.soldQuantity <
                    product?.flashSale?.quantity &&
                  product?.fsPrice
                ? product?.fsPrice
                : product?.finalPrice
            }
          />
          {/*product?.preOrder && (
            <div
              className={`h-[30px] pt-1.5 ${
                !product?.preOrder && type === 'list' ? 'hidden' : ''
              }`}
            >
              {product?.preOrder && (
                <Link
                  href={
                    '/' +
                    getTranslate(product.slugs.value) +
                    product.slugs.postfix
                  }
                >
                  <PreOrderCard
                    price={product?.preOrder.salePrice}
                    type={ProductCardType.PRODUCT_CARD}
                  />
                </Link>
              )}
            </div>
          )*/}
          {type == ProductCardType.FLASH_SALE && product?.flashSale && (
            <div className={`h-[28px] py-1 list mb-2`}>
              <ProgressBar
                fsType={product.type}
                flashSale={product?.flashSale}
                type={ProductCardType.PRODUCT_CARD}
              />
            </div>
          )}
        </div>
        {/* {!product?.flashSale && type !== ProductCardType.FLASH_SALE && (
          <PolicyCard policy={product?.properties} />
        )} */}
        <div
          className={`${
            type &&
            ['flashSale', 'trending', 'recommended', 'list'].includes(type)
              ? ''
              : ''
          }`}
        >
          {/*product?.coupons && product?.coupons.length > 0 && (
            <div
              className={`voucher mt-1 flex mx-2 gap-1 mb-2 leading-tight rounded border px-1 py-1 ${
                token
                  ? 'border-green-300 bg-green-200'
                  : 'border-red-100 bg-red-50'
              }`}
            >
              <Image
                src={
                  token
                    ? '/assets/icons/voucher-icon-login.svg'
                    : '/assets/icons/voucher-icon.svg'
                }
                width={20}
                height={20}
                alt='voucher'
                className='w-5 flex-[0_0_20px] max-w-[20px]'
              />
              {voucherDisplay?.showValue ? (
                <div className='flex flex-col leading-tight'>
                  <span
                    className={`text-SmallTitle font-bold ${
                      token ? ' text-green-700' : ' text-dark-900'
                    }`}
                  >
                    Giá voucher:{' '}
                    <span className={`text-orange`}>
                      {(voucherDisplay?.percentValue &&
                        finalPriceWithPercent) ||
                        finalPriceWithFixed}
                    </span>
                  </span>
                  <span
                    className={`text-SmallTitle line-clamp-1 ${
                      token
                        ? 'font-normal text-green-700'
                        : 'font-normal text-dark-800'
                    }`}
                  >
                    {getTranslate(voucherDisplay.name)}
                  </span>
                </div>
              ) : (
                <div className='flex flex-grow-0 text-xs'>
                  <span
                    className={`line-clamp-2 font-bold leading-tight ${
                      token ? 'text-green-900' : 'text-dark'
                    }`}
                  >
                    {getTranslate(voucherDisplay?.name)}
                  </span>
                </div>
              )}


            </div>
          ) */}

          {/* Deal hời */}
          {showDeal &&
            type === ProductCardType.FLASH_SALE &&
            product.flashSale &&
            product.flashSale?.quantity > product.flashSale?.soldQuantity && (
              <div className='flex mt-1 mx-2 h-[31px] items-center justify-center border border-[#f00000] rounded-[30px] text-[#f00000] font-semibold cursor-pointer'>
                <button
                  className='block w-full h-full'
                  onClick={() =>
                    addToCart(product, AddToCartType.ADD).then(() => {
                      router.push('/checkout/cart')
                    })
                  }
                  disabled={cartLoading}
                >
                  MUA DEAL HỜI
                </button>
              </div>
            )}

          <div className='rate-compare flex justify-between flex-wrap mb-2'>
            {/* Rating */}
            {showRate && (
              <div className='flex pl-2 mb-2 pt-1'>
                <div className='flex text-center justify-start'>
                  <StarRatings
                    starRatedColor='#FFCD4B'
                    numberOfStars={1}
                    rating={product?.average ? product?.average : 5}
                    starDimension='15px'
                    starSpacing='1px'
                    svgIconPath='M20 0L26.1803 13.1672L40 15.2786L30 25.5279L32.3607 40L20 33.1672L7.63932 40L10 25.5279L0 15.2786L13.8197 13.1672L20 0Z'
                    svgIconViewBox='0 0 40 40'
                  />
                  <div className='flex items-center pl-1 text-xs pt-0.5 leading-6 text-[#000] italic'>
                    {product?.average || 5}
                    <span className='pl-2'>
                      {' '}
                      {`(Đã bán ${product?.orderQuantity || 0})`}
                    </span>
                  </div>
                </div>
              </div>
            )}
            {/* compare */}
            {showCompare && (
              <div
                className='flex gap-1 px-2 items-center text-linkPico text-xs cursor-pointer'
                onClick={() => {
                  if (handleAddToCompare) {
                    handleAddToCompare(product, isCompare())
                  }
                }}
              >
                <span className='flex items-center leading-4 justify-center w-3 h-3 rounded-full'>
                  {isCompare() ? (
                    <img
                      src={assetUrl('/assets/icons/compare-check.svg')}
                      alt='compare-check'
                    />
                  ) : (
                    <img
                      src={assetUrl('/assets/icons/compare-plus.svg')}
                      alt='compare-check'
                    />
                  )}
                </span>
                <span>So sánh</span>
              </div>
            )}
          </div>

          {type === ProductCardType.FLASH_SALE_TIME &&
            product.flashSale &&
            product.flashSale?.quantity > product.flashSale?.soldQuantity && (
              <div className='flex mx-2 h-[31px] items-center justify-center border border-[#f00000] rounded-[30px] text-[#f00000] font-semibold cursor-pointer'>
                <button
                  className='block w-full h-full'
                  onClick={() =>
                    addToCart(product, AddToCartType.ADD).then(() => {
                      router.push('/checkout/cart')
                    })
                  }
                  disabled={cartLoading}
                >
                  SẮP DIỄN RA
                </button>
              </div>
            )}
        </div>
      </div>
    </div>
  )
}

export default ProductCard
